import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/share';
import { UrlManagerService } from './url-manager.service';
import { LoginService } from './login.service'
import { Router } from '@angular/router';

@Injectable()
export class LocationService {

  constructor(private http: Http, private UrlManager: UrlManagerService, private router: Router) {
  }


  getLocations() {
    console.log("here");
    var Observable = this.http.get(this.UrlManager.getApiUrl() + "/location/v1", this.UrlManager.getOptions()).map(res => res.json()).share();
    Observable.subscribe((res) => { }, (error) => {
      console.log("Hello, go home " + error);
      if (error.status == 401 || error.status == 403) {
          console.log(error);
          console.log("going home, hopefully");
          this.router.navigate(['home'], {queryParams: { status: "Unauthorized" }});
      }
    });
    return Observable;
  }

  getLocation(locationId) {
    var Observable = this.http.get(this.UrlManager.getApiUrl() + "/location/v1/" + locationId, this.UrlManager.getOptions()).map(res => res.json()).share();
    Observable.subscribe((res) => { }, (error) => {
        if (error.status == 401 || error.status == 403) {
            console.log(error);
            this.router.navigate(['home'], {queryParams: { status: "Unauthorized" }});
        }
    });
    return Observable;
  }

  postLocation(location) {
    var Observable = this.http.post(this.UrlManager.getApiUrl() + "/location/v1", location, this.UrlManager.getOptions()).share()
    Observable.subscribe((res) => { }, (error) => {
      if (error.status == 401 || error.status == 403) {
          console.log(error);
          this.router.navigate(['home'], {queryParams: { status: "Unauthorized" }});
      }
    });
    return Observable;
  }

  putLocation(location) {
    var Observable = this.http.put(this.UrlManager.getApiUrl() + "/location/v1/" + location.code, location, this.UrlManager.getOptions()).share()
    Observable.subscribe((res) => { }, (error) => {
      if (error.status == 401 || error.status == 403) {
          console.log(error);
          this.router.navigate(['home'], {queryParams: { status: "Unauthorized" }});
      }
    });
    return Observable;
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/location.service.ts